import React, { useEffect } from 'react';
import Slider from "react-slick";
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import EngImg from "../../../../../Assets/img/engagement-rings.png"
import FineImg from "../../../../../Assets/img/finest-jewelry.png"
import AddImg from "../../../../../Assets/img/Address Banner - G Fever.png"
import AddImg1 from "../../../../../Assets/img/STAR DIAMONDdd.jpg"
import AddImgMob from "../../../../../Assets/img/star_diamond_mob.jpg"
let sliderData = [
  {
   img : AddImg1,
   link : "/contact"
  },
  {
    img: EngImg,
    link: '/ringsettings'
  },
  {
    img: FineImg,
    link: '/jewelry/fine-jewelry'
  },
  // {
  //   img: `${ImageUrl}theme/macau/sl3.jpg`,
  //   link: '/jewelry/wedding-rings'
  // }
]
const MacauSlider = () => {
  var settings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 500,
    accessibility: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => {
      document
        .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
        .forEach(el => el.setAttribute('tabindex', '-1'));
    },
    afterChange: () => {
      document
        .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
        .forEach(el => el.removeAttribute('tabindex'));
    },
    responsive: [
      {
        breakpoint: 1024, // Tablet and below
        settings: {
          arrows: false
        }
      },
      {
        breakpoint: 768, // Mobile devices
        settings: {
          arrows: false
        }
      }
    ]
  };
  return (
    <>


      <Slider {...settings} className='overflow-hidden bannerSliderHome'>
        {sliderData?.map((val, index) =>
          <div key={index}>
            <NavLink to={val.link}>
              <LazyLoadImage src={val?.img} alt="slider" className='img-fluid' />
            </NavLink>
          </div>
        )}
      </Slider>
    </>
  )
}

export default MacauSlider;